import React from 'react';
import { Button } from './ui/Button';
import { Download } from 'lucide-react';
const FLYER_PDF_URL = 'https://drive.google.com/file/d/1hBw-jZ4q1niS-dJrxDPCCOeQijbswc3I/view?usp=sharing';
export function FlyerSection() {
  return <section id="flyer" className="py-24 bg-white" data-id="element-48">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-49">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-6" data-id="element-50">
          Submit an Essay
        </h2>

        <p className="text-xl text-gray-700 mb-10" data-id="element-51">
          Essay submissions are organized in partnership with Harrisonburg and Rockingham County schools.
          Please download the flyer below for instructions in multiple
          languages.
        </p>

        <div className="mb-12" data-id="element-52">
          <Button href={FLYER_PDF_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2" data-id="element-53">
            <Download className="w-5 h-5" data-id="element-54" />
            View Flyer
          </Button>
        </div>

        <div className="max-w-2xl mx-auto bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/ppSRQ7Cjq7HoPjpD1Nf8vy/Screenshot_2026-02-02_at_12.49.05_PM.png" alt="Essay Submission Flyer" className="w-full h-auto rounded-lg" data-id="element-56" />
        </div>
      </div>
    </section>;
}